/**
 * Central African CFA franc.
 */
export var XAF = {
  code: 'XAF',
  base: 10,
  exponent: 0
};